export default "__VITE_ASSET__fb3880fa__"